import { TooltipStyled } from "./Tooltip.styled";

interface TooltipSubject {
  name: string;
  value?: number | string;
  nameColor?: string;
  valueColor?: string;
}

interface TooltipInfo {
  name?: string;
  value?: number | string;
  percent?: number | string;
  color?: string;
  markerColor?: string;
}

interface Props {
  width?: string;
  subjects?: TooltipSubject[];
  infos?: TooltipInfo[];
  showMarker?: boolean;
}

export function Tooltip({
  width = "auto",
  subjects = [],
  infos = [],
  showMarker = false
}: Props) {
  return (
    <TooltipStyled width={width}>
      <div className="subject-wrapper">
        {subjects.map((subject) => {
          const { nameColor, name, valueColor, value } = subject;
          return (
            <div className="subject">
              {nameColor && (
                <span
                  style={{
                    backgroundColor: nameColor,
                    width: 6,
                    height: 6,
                    borderRadius: "50%",
                    display: "inline-block",
                    marginRight: 4
                  }}
                />
              )}
              {value && <span style={{ color: valueColor }}>{value}</span>}
              <span data-testid="subject-label">{name}</span>
            </div>
          );
        })}
      </div>
      <div className="info-wrapper">
        {infos.map((info) => {
          return (
            <div data-testid="info" className="info">
              {info.name !== undefined && (
                <div className="info-name">
                  {showMarker && (
                    <div
                      className="marker"
                      style={{ background: info.markerColor }}
                    />
                  )}
                  <div>{info.name}</div>
                </div>
              )}
              {info.value !== undefined && (
                <div className="info-value">
                  {info.value}
                  {info.percent !== undefined && (
                    <div className="info-value-percent">({info.percent}%)</div>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </TooltipStyled>
  );
}
